/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-12-17T18:26:38.244
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'report-reportfinancialrentcontractdetailcollection-'

export default 
{
path: '/report/reportfinancialrentcontractdetailcollection',
name: 'report-reportfinancialrentcontractdetailcollection',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}reportfinancialrentcontractdetailcollection-index',

meta:{
...meta,
title: '实收报表'
},

component: () => import('@/pages/report/reportfinancialrentcontractdetailcollection/index') ,
},
{
path: 'detail-edit/:id',
name: '${pre}reportfinancialrentcontractdetailcollection-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '实收报表编辑'
},

component: () => import('@/pages/report/reportfinancialrentcontractdetailcollection/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}reportfinancialrentcontractdetailcollectiondetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '实收报表新增'
},

component: () => import('@/pages/report/reportfinancialrentcontractdetailcollection/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}reportfinancialrentcontractdetailcollectionView',
auth: [
'hidden'
],

meta:{
...meta,
title: '实收报表详情查看'
},

component: () => import('@/pages/report/reportfinancialrentcontractdetailcollection/detail-view') ,
},
]
};
